module.exports = __webpack_public_path__ + "img/set_phone@3x.c1d1d410.png";